<template>
    <form class="form" autoComplete="off" :id=formName :name=formName noValidate="" method="POST">
        <div class="form-group">
            <label for="inputPasswordOld">Current Password</label>
            <input type="password" class="form-control" id="inputPasswordOld" required="" />
        </div>
        <div class="form-group">
            <label for="inputPasswordNew">New Password</label>
            <input type="password" class="form-control" id="inputPasswordNew" required="" />
            <span class="form-text small text-muted">
                The password must be 8-20 characters, and must <em>not</em> contain spaces.
            </span>
        </div>
        <div class="form-group">
            <label for="inputPasswordNewVerify">Verify</label>
            <input type="password" class="form-control" id="inputPasswordNewVerify" required="" />
            <span class="form-text small text-muted">
                To confirm, type the new password again.
            </span>
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg float-right">{{ submitBtnText }}</button>
        </div>
    </form>
</template>
<script>
export default {
    props: {
        submitBtnText: {
            type: String,
            default: "Submit"            
        }
    }
};
</script>
